import React from 'react'
import { useTranslation } from 'react-i18next';

function InputError({ text, touched }) {
  const {t}=useTranslation()
  return text && touched ? <p className='text-danger'>{t(text)}</p> : null
}

export default InputError
